// Import modules directly to avoid type issues
import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import translations
import translationEN from './locales/en/translation.json';
import translationAR from './locales/ar/translation.json';

// The translations
const resources = {
  en: {
    translation: translationEN
  },
  ar: {
    translation: translationAR
  }
};

// Language detector options
const detectionOptions = {
  // Order and from where user language should be detected
  order: ['localStorage', 'navigator'],
  
  // Keys or params to lookup language from
  lookupLocalStorage: 'i18nextLng',
  
  // Cache user language on
  caches: ['localStorage'],
  
  // Only detect languages that are in the 'resources' object
  checkWhitelist: true
};

// Create i18n instance
const i18n = i18next
  // Detect user language
  .use(LanguageDetector)
  // Pass the i18n instance to react-i18next
  .use(initReactI18next)
  // Init i18next
  .init({
    resources,
    fallbackLng: 'en',
    debug: process.env.NODE_ENV === 'development',
    detection: detectionOptions,
    
    interpolation: {
      escapeValue: false // React already safes from XSS
    },
    
    // RTL support for Arabic
    react: {
      useSuspense: true,
    }
  });

// Helper function to change language and save user preference
export const changeLanguage = (lng: 'en' | 'ar') => {
  localStorage.setItem('i18nextLng', lng);
  void i18next.changeLanguage(lng);
  
  // Set RTL/LTR direction for the whole document based on language
  document.documentElement.dir = lng === 'ar' ? 'rtl' : 'ltr';
  document.documentElement.lang = lng;
};

// Set initial document direction based on current language
document.documentElement.dir = i18next.language === 'ar' ? 'rtl' : 'ltr';
document.documentElement.lang = i18next.language;

// Export default instance
export default i18next; 